<template>
  <div class="error" :style="'top: ' + topOffset + 'px'">
    <div class="txt">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: "ErrorPopup",
  props: {
    message: {
      type: String,
      default: function () {
        return  this.$t('errorPopup.defaultMessage')
      }
    },
    topOffset: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss">
.error {
  padding-left: 7px;
  display: inline-block;
  position: absolute;
  z-index: 4000;
  background-image: url("../../assets/icons/frm-field-error-arrow.png");
  background-repeat: no-repeat;
  background-position: left center;
  left: 99%;
  width: 200px;
}

.error .txt {
    display: inline-block;
    padding: 16px 19px 14px 19px;
    font-size: 14pX;
    font-weight: 600;
    color: #FFF;

    background: #373737; /* Old browsers */
    /* IE9 SVG, needs conditional override of 'filter' to 'none' */
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzM3MzczNyIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMyMDIwMjAiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
    background: -moz-linear-gradient(top, #373737 0%, #202020 100%); /* FF3.6+ */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #373737), color-stop(100%, #202020)); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(top, #373737 0%, #202020 100%); /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(top, #373737 0%, #202020 100%); /* Opera 11.10+ */
    background: -ms-linear-gradient(top, #373737 0%, #202020 100%); /* IE10+ */
    background: linear-gradient(to bottom, #373737 0%, #202020 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#373737', endColorstr='#202020', GradientType=0); /* IE6-8 */

    /* Old IE fix*/
    *zoom: inline;
    *display: inline;
}
</style>




// WEBPACK FOOTER //
// src/components/ui/ErrorPopup.vue